import BannerHero from "@/components/bannerHero";
import ContactSection from "@/components/ContactArea";
import EventSection from "@/components/event/EventSection";

export default function Event() {
  return (
    <>
      <BannerHero
        title="Our Events"
        bgImage="/images/events/events-bg.png"
        className="events-bg"
      />

      <section className="eventspace">
        <EventSection />
      </section>


    </>
  );
}
